













































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const indexModule = namespace("linkedOrder");
let minDate: any = new Date();
minDate.setMonth(minDate.getMonth() - 2);
minDate.setDate(1);

let defaultDate: any = new Date();
defaultDate.setDate(defaultDate.getDate() - 1);

import { Toast } from "vant";
import axios from "axios";
const $http = axios.create({
	// headers: {'X-Custom-Header': 'foobar'}
});

@Component
export default class LinkedOrder extends Vue {
	mainInfo: any = "";
	date: any = "";
	orderNo: any = "";
	orderAmount: any = "";
	imageList: any = [];
	show = false;
	minDate = minDate;
	defaultDate = [defaultDate, new Date()];
	list: Array<any> = [];
	loading = false;
	finished = false;
	result: string[] = [];
	showPlan = false;
	showBtn = false;
	pageNum = 0;

	get action() {
		return this.$http["FILE_UPLOAD"].api;
	}

	formatDate(date: any) {
		return this.$format(date, "YYYY/MM/DD");
	}

	onSearch() {
		this.pageNum = 0;
		this.getCouponList(0, true);
	}
	onConfirm(date: any) {
		const [start, end] = date;

		this.show = false;
		this.date = this.formatDate(date);
		this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
		this.pageNum = 0;
		this.getCouponList(0, true);
	}

	getCouponList(pageNum: any = 0, reset: boolean = false) {
		let date = this.date ? this.date.split("-") : [];
		this.$store
			.dispatch("linkedOrder/getCouponList", {
				mainInfo: this.mainInfo,
				pageNum: this.pageNum + 1,
				businessEntityId: this.$global.tenantId,
				writeoffStartTime: date[0],
				writeoffEndTime: date[1],
			})
			.then((res) => {
				if (reset) {
					this.list = [];
				}
				if (res.success) {
					res.success.data.list.forEach((item: any) => {
						item.time = this.$format(
							item.writeoffTime,
							"YYYY-MM-DD HH:mm:ss"
						);
						if (this.$route.query) {
							const qrCode: string = String(
								this.$route.query.qrCode || ""
							);
							if (
								qrCode &&
								this.result.indexOf(qrCode) < 0 &&
								item.qrCode == qrCode
							) {
								this.result.push(qrCode);
								this.showPlan = true;
							}
						}
						this.list.push(item);
					});
					this.pageNum = res.success.data.pageNum;
				} else {
				}
				this.loading = false;
				if (res.success.data.pageNum == res.success.data.pages) {
					this.finished = true;
				}
			});
	}

	onUploadDelete(url: any) {
		let index = this.imageList.indexOf(url);
		this.imageList.splice(index, 1);
	}

	onUplodaed(val: any, index: any) {
		//图文图片上传
		// console.log(index);
		const param = new FormData();
		param.append("file", val.file);
		$http
			.post(this.action, param, {
				headers: {
					"Content-Type": "multipart/form-data",
					token: this.$global.token,
					tenantId: this.$global.tenantId,
					tenantType: this.$global.tenantType,
				},
			})
			.then((res) => {
				if (res.data.status == 200) {
					if (res.data.data.path) {
						this.imageList.push({ url: res.data.data.path });
					}
				} else if (
					res.data.status == 81003 ||
					res.data.status == 82023
				) {
					const wx: any = (window as any).wx;
					(wx as any).miniProgram.reLaunch({
						url: "/pages/login/login?status=1",
					});
				} else {
					Toast(res.data.message);
				}
			})
			.catch((err) => {
				Toast("文件上传出错:" + err.message);
			});
	}

	LinkedOrder() {
		const amount: number = Number(this.orderAmount) * 100;
		if (amount && amount < 1) {
			this.$notify({
				type: "danger",
				message: "订单金额必须大于0.01元!",
			});
			return;
		}
		this.$store
			.dispatch("linkedOrder/LinkedOrder", {
				qrCodeList: this.result,
				orderNo: this.orderNo,
				orderAmount: amount,
				imageList: this.imageList.map((item: any) => item.url),
			})
			.then((res) => {
				if (res.success) {
					this.$notify({ type: "success", message: "关联成功" });
					this.result = [];

					this.pageNum = 0;
					this.getCouponList(0, true);
				} else {
					this.$notify({ type: "danger", message: res.error.msg });
				}
				this.showPlan = false;
			});
	}
	change(list: any) {
		if (list.length) {
			this.showBtn = true;
		} else {
			this.showBtn = false;
		}
	}

	toggle(index: number) {
		(this.$refs as any).checkboxes[index].toggle();
	}

	showPlanHandler() {
		this.orderNo = "";
		this.orderAmount = "";
		try {
			(this.$refs as any).form.resetValidation();
		} catch {}
	}

	onSubmit(values: any) {
		this.LinkedOrder();
	}
}
